(function (window, document, $) {

    // This template is used for a landingpage for a campaign to get people to subscribe. 
    // These users might have an abosid and this function adds that id to the links to the subscription form.
    if ($('.page-template-page-what-is-yogatv').length) {
        var abosid = window.getUrlParameter('abosid');

        if (!abosid) {
            return false;
        }

        $('.page-wrap a').each(function(index) {
            var url = $(this).attr('href');
            var extra_parameter = false;

            if (url.indexOf("abonnement") >= 0) {
                if (url.indexOf("?") >= 0) {
                    extra_parameter = true;
                }

                url += (extra_parameter ? '&' : '?') + 'abosid='+abosid;
                $(this).attr('href', url);
            }
        })
    }

}(window, document, jQuery));
